import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from '../DocumentTypeField.module.css';
export const ComboBoxItem = ({ item }) => {
    return (_jsxs("div", { className: classes.row, children: [_jsx("p", { children: item.code }), _jsx("p", { children: item.name })] }));
};
